import type { PrimitiveKeyInterface } from '@zaoblako/shared/common/interfaces/primitive-key.interface';
import type { SerdeCheckerInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-checker.interface';
import type { SerdeContextDataInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context-data.interface';

/** Global service object which contains backend checkers for SerDe */
export class SerdeCheckersRegistryClass {
  public static instance: SerdeCheckersRegistryClass = null;

  public static getInstance(): SerdeCheckersRegistryClass {
    if (!SerdeCheckersRegistryClass.instance) {
      SerdeCheckersRegistryClass.instance = new SerdeCheckersRegistryClass();
    }
    return SerdeCheckersRegistryClass.instance;
  }

  private readonly checkers = new Map<PrimitiveKeyInterface, SerdeCheckerInterface<any>>();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  /**
   * Add checker to registry. If another checker with received key exists then it will be replaced.
   *
   * @param key Checker unique key
   * @param checker Checker
   */
  public addChecker(key: PrimitiveKeyInterface, checker: SerdeCheckerInterface<any>): void {
    this.checkers.set(key, checker);
  }

  /**
   * Is there a checker with the received key in the registry?
   *
   * @param key Checker unique key
   *
   * @returns Check result (`true` - exists, `false - not exists)
   */
  public hasChecker(key: PrimitiveKeyInterface): boolean {
    return this.checkers.has(key);
  }

  /**
   * Get checker by key
   *
   * @param key Checker unique key
   *
   * @returns Checker or `undefined` if checker not found
   */
  public getChecker<T = any, D extends SerdeContextDataInterface = SerdeContextDataInterface>(key: PrimitiveKeyInterface): SerdeCheckerInterface<T, D> {
    return this.checkers.get(key);
  }
}
